import { AND, GE, RESULT, TYPE, UID, UID_IN } from 'shared/api/query/constants';
import {
  goalChange as goalChangeConfig,
  goal as goalConfig,
  goalCycle as goalCycleConfig,
  property as propertyConfig,
  propertyOption as propertyOptionConfig,
  propertyValue as propertyValueConfig,
  space as spaceConfig,
  user as userConfig,
} from 'shared/api/query/configs.json';

const snapshotChildren = [
  { attr: UID },
  { attr: propertyValueConfig.edges.timestamp, default: null },
  { attr: propertyValueConfig.edges.number, default: null },
  { attr: propertyValueConfig.edges.text, default: null },
  { attr: propertyValueConfig.edges.document, default: null },
  { attr: propertyValueConfig.edges.property, model: propertyConfig.model, children: [{ attr: UID }] },
  { attr: propertyValueConfig.edges.users, model: userConfig.model, default: [], children: [{ attr: UID }] },
  { attr: propertyValueConfig.edges.selectedOptions, model: propertyOptionConfig.model, default: [], children: [{ attr: UID }] },
  { attr: propertyValueConfig.edges.spaces, model: spaceConfig.model, default: [], children: [{ attr: UID }] },
];

export const goalChangeChildren = [
  { attr: UID },
  { attr: goalChangeConfig.edges.field },
  { attr: goalChangeConfig.edges.changedAt },
  { attr: goalChangeConfig.edges.goal, model: goalConfig.model, default: null, children: [{ attr: UID }] },
  { attr: goalChangeConfig.edges.previousValue, default: null },
  { attr: goalChangeConfig.edges.value, default: null },
  { attr: goalChangeConfig.edges.previousDescription, default: null },
  { attr: goalChangeConfig.edges.description, default: null },
  { attr: goalChangeConfig.edges.actor, model: userConfig.model, default: null, children: [{ attr: UID }] },
  { attr: goalChangeConfig.edges.property, model: propertyConfig.model, default: null, children: [{ attr: UID }] },
  { attr: goalChangeConfig.edges.previousPropertyValue, model: propertyValueConfig.model, default: null, children: snapshotChildren },
  { attr: goalChangeConfig.edges.propertyValue, model: propertyValueConfig.model, default: null, children: snapshotChildren },
  {
    attr: goalChangeConfig.edges.relatedGoal,
    model: goalConfig.model,
    default: null,
    children: [{ attr: UID }, { attr: goalConfig.edges.title }, { attr: goalConfig.edges.icon }],
  },
  ...[goalChangeConfig.edges.previousGoalCycles, goalChangeConfig.edges.goalCycles].map((attr) => ({
    attr,
    model: goalCycleConfig.model,
    default: [],
    children: [{ attr: UID }, { attr: goalCycleConfig.edges.title }, { attr: goalCycleConfig.edges.color }],
  })),
];

export const goalChangeList = ({ goalId, since, pagination }) => [
  {
    alias: RESULT,
    model: goalChangeConfig.model,
    func: { name: TYPE, args: [{ value: goalChangeConfig.model }] },
    filter: {
      op: AND,
      child: [
        { func: { name: UID_IN, attr: goalChangeConfig.edges.goal, args: [{ value: `${goalId}` }] } },
        { func: { name: GE, attr: goalChangeConfig.edges.changedAt, args: [{ value: since.toISOString() }] } },
      ],
    },
    order: [{ attr: goalChangeConfig.edges.changedAt, desc: true }],
    pagination,
    default: [],
    children: goalChangeChildren,
  },
];

export const goalChangesByIds = ({ goalId, ids }) => [
  {
    alias: RESULT,
    model: goalChangeConfig.model,
    func: { name: UID },
    uid: ids,
    filter: { func: { name: UID_IN, attr: goalChangeConfig.edges.goal, args: [{ value: `${goalId}` }] } },
    default: [],
    children: goalChangeChildren,
  },
];
